import { fetchTechniciansApi } from './api'
import { isLoggedIn } from '@utils/auth'
import { getRootTranslator } from '@utils/get-module-translator'
import { transformTechnicianPickerOptions } from '@data/user'
const _tc = getRootTranslator()

export const state = {
  users: [],
  total: null,
}

export const getters = {
  technicianOptions(state) {
    return [
      {
        key: 0,
        id: 0,
        text: _tc('unassigned'),
        name: _tc('unassigned'),
        email: null,
        avatar: 'user',
        avatarType: 'icon',
        isTenant: false,
      },
    ].concat(state.users.map(transformTechnicianPickerOptions))
  },
  technician(state) {
    return (id) => {
      return state.users.find((t) => t.id === id) || {}
    }
  },
}

export const mutations = {
  SET_USERS(state, data) {
    // Freeze the technician directory so Vue 2 skips reactivity on all ~5k users
    // (same pattern as the status/category modules). This removes the ~657k reactive
    // AccessorPairs + the per-picker Watcher depId Sets that dominated the JS heap.
    state.users = Object.freeze(data)
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
}

export const actions = {
  init({ dispatch }) {
    if (isLoggedIn()) {
      dispatch('fetch')
    }
  },

  fetch({ commit }, params) {
    return fetchTechniciansApi(params).then(({ users, total }) => {
      commit('SET_USERS', users)
      commit('SET_TOTAL', total)
    })
  },

  destroy({ commit }) {
    commit('SET_USERS', [])
    commit('SET_TOTAL', null)
  },
}
